import { watch, type ComputedRef, type Ref, type WatchStopHandle } from 'vue';
import type { ExtrudeViewportAdapter } from '@/composables/extrude-types';
import { BlendPreviewGuideOverlayController } from './BlendPreviewGuideOverlayController';
import type { BlendPreviewGuideOverlayState, BlendPreviewGuideViewportAdapter } from './types';

/**
 * 注册圆角/倒角预览引导。
 *
 * @param input 注册参数。
 * @returns 释放句柄。
 */
export function registerBlendPreviewGuideOverlay(input: {
  viewportRef: Ref<ExtrudeViewportAdapter>;
  overlayState: ComputedRef<BlendPreviewGuideOverlayState>;
  onControlPointSelect?: (key: string) => void;
}): {
  dispose: () => void;
} {
  const controller = new BlendPreviewGuideOverlayController({
    onControlPointSelect: input.onControlPointSelect,
    getViewport: () => {
      const viewport = input.viewportRef.value;
      if (!viewport.resolveObjectWorldPoint) {
        return null;
      }
      return viewport as BlendPreviewGuideViewportAdapter;
    },
  });

  const stopWatch: WatchStopHandle = watch(
    () => input.overlayState.value,
    (state) => {
      controller.sync(state);
    },
    {
      deep: true,
      immediate: true,
    },
  );

  return {
    dispose: () => {
      stopWatch();
      controller.dispose();
    },
  };
}
